if ('mediaSession' in navigator) {
  navigator.mediaSession.setActionHandler('play', function() {});
  navigator.mediaSession.setActionHandler('pause', function() {});
  navigator.mediaSession.setActionHandler('stop', function() {});
  navigator.mediaSession.setActionHandler('seekbackward', function() {});
  navigator.mediaSession.setActionHandler('seekforward', function() {});
  navigator.mediaSession.setActionHandler('previoustrack', function() {});
  navigator.mediaSession.setActionHandler('nexttrack', function() {});
}

function waitForElement(selector, callback, interval = 100, timeout = 10000) {
  const startTime = Date.now();
  const check = setInterval(() => {
    const element = document.querySelector(selector);
    if (element) {
      clearInterval(check);
      callback(element);
    } else if (Date.now() - startTime >= timeout) {
      clearInterval(check);
      console.error(`Element "${selector}" not found within timeout.`);
    }
  }, interval);
}

function lerp(start, end, amount) {
  return start * (1 - amount) + end * amount;
}

function easeOutCubic(x) {
  return 1 - Math.pow(1 - x, 3);
}

function populateScrollingText() {
  if (sessionStorage.getItem("voice") === 'meow') {
    meowifyScrollingText();
    return;
  }
  document.querySelectorAll(`.scrolling-text`).forEach((el) => {
    el.innerHTML = '';
    const text = el.getAttribute('data-text');
    const speed = parseFloat(el.getAttribute('data-speed'));

    var textEl = document.createElement('span');
    textEl.innerText = text;
    el.appendChild(textEl);

    var speedScale = textEl.clientWidth / 100;
    el.style.animationDuration = `${speed * speedScale}s`;

    var numEls = Math.ceil(el.parentElement.clientWidth / textEl.clientWidth) + 2;

    for (var i = 0; i < numEls; i++) {
      const textElClone = textEl.cloneNode(true);
      textElClone.setAttribute('aria-hidden', 'true');
      el.appendChild(textElClone);
    }
  });
}

function scaleLargeText() {
  if (document.visibilityState != 'visible') {
    document.addEventListener('visibilitychange', scaleLargeText, { once: true });
    return;
  }
  const largeTextElements = document.querySelectorAll('.large-text');
  let clip = false;
  let clipAmnt = 0;
  largeTextElements.forEach((el) => {
    clip = el.hasAttribute('data-clip-text');
    clipAmnt = el.dataset.clipAmount || 0;

    const textElement = el.querySelector(`span`);
    textElement.style.fontSize = '100px';
    var scaleFactor = document.body.clientWidth / textElement.offsetWidth;
    if (clip) {
      scaleFactor *= 1 + (clipAmnt * 0.125);
    } else {
      scaleFactor *= 0.975;
    }

    const currFontSize = parseFloat(window.getComputedStyle(textElement, null).getPropertyValue('font-size'));

    textElement.style.fontSize = `${scaleFactor * currFontSize}px`;
    textElement.style.opacity = 1;
  });
}

function renderAccordion(acc) {
  var panel = acc.querySelector(".accordion-content");
  if (acc.classList.contains("open")) {
    panel.style.maxHeight = panel.scrollHeight + 1 + "px";
  } else {
    panel.style.maxHeight = "0";
  }
}

function renderAccordions() {
  document.querySelectorAll('.accordion').forEach((acc) => renderAccordion(acc));
}

function formatMoney(cents, format = "${{amount}}") {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var value = (cents / 100).toFixed(2);
  if (format.includes('no_decimals')) {
    value = Math.round(value);
  }
  return format.replace(/\{\{[\w ]+\}\}/, value);
}

function populateScrollingImages() {
  const scrollingImagesWrappers = document.querySelectorAll(`.scrolling-images-wrapper`);

  scrollingImagesWrappers.forEach((wrapper) => {
    const containerWidth = wrapper.clientWidth;
    const scrollingImages = wrapper.querySelector('.scrolling-images');
    const scrollSpeed = scrollingImages.dataset.scrollSpeed || 1;
    const scrollingWidth = scrollingImages.clientWidth;
    const images = scrollingImages.querySelectorAll('img:not(.scrolling-images__clone)');
    if (images.length === 0) {
      return;
    }
    const currClones = scrollingImages.querySelectorAll('.scrolling-images__clone');

    const imagesWidth = [...images].reduce((acc, image) => {
      return acc + image.clientWidth;
    }, 0);

    if (scrollingWidth < containerWidth * 2 || !scrollingImages.hasAttribute('data-initialized')) {
      currClones.forEach((clone) => {
        clone.remove();
      });

      var cloneSets = Math.ceil(containerWidth * 2 / imagesWidth);
      if (cloneSets % 2 != 0) {
        cloneSets++;
      }
      cloneSets--;

      for (var i = 0; i < cloneSets; i++) {
        images.forEach((image) => {
          const clone = image.cloneNode(true);
          clone.classList.add('scrolling-images__clone');
          scrollingImages.appendChild(clone);
        });
      }
    }

    if (!scrollingImages.hasAttribute('data-initialized')) {
      scrollingImages.setAttribute('data-initialized', 'true');
    }

    var speedScale;

    if (images.length === 1 && scrollingWidth < containerWidth * 2) {
      speedScale = scrollingImages.clientWidth / 2 / images[0].clientWidth / 2;
    } else {
      var averageImageWidth = imagesWidth / images.length;
      speedScale = scrollingImages.clientWidth / 2 / averageImageWidth / 2;
    }

    scrollingImages.style.animationDuration = `${scrollSpeed * speedScale}s`;
  });
}

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    e.target.querySelector("#add-to-cart").classList.add('loading');

    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    await syncCart();
    e.target.querySelector("#add-to-cart").classList.remove('loading');

    openDrawer('cart');
  });
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openDrawer('cart');
  });
});

window.addEventListener('resize', () => {
  document.querySelectorAll('.accordion').forEach((acc) => renderAccordion(acc));
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.accordion').forEach((acc) => {
    renderAccordion(acc);

    var header = acc.querySelector(".accordion-header");
    header.addEventListener("click", function() {
      acc.classList.toggle("open");
      var panel = acc.querySelector(".accordion-content");
      if (acc.classList.contains("open")) {
        panel.style.maxHeight = panel.scrollHeight + 1 + "px";
      } else {
        panel.style.maxHeight = "0";
      }
    });
  });
});

document.querySelectorAll('.large-text').forEach((el) => {
  el.addEventListener('visibilitychange', scaleLargeText);
});

document.addEventListener('DOMContentLoaded', scaleLargeText);

window.addEventListener('resize', scaleLargeText);

window.addEventListener('orientationchange', scaleLargeText);

document.addEventListener('shopify:section:load', scaleLargeText);

document.addEventListener('DOMContentLoaded', () => {
  const money_format = document.querySelector('meta[name="money_format"]').getAttribute('content');
  const prefix = money_format.split("{{")?.[0];
  const suffix = money_format.split("}}")?.[1];

  document.querySelectorAll('.curr-before').forEach((el) => {
    if (prefix === undefined || prefix.trim() === '') {
      el.remove();
    } else {
      el.innerText = prefix;
    }
  });

  document.querySelectorAll('.curr-after').forEach((el) => {
    if (suffix === undefined || suffix.trim() === '') {
      el.remove();
    } else {
      el.innerText = suffix;
    }
  });
});

document.addEventListener('DOMContentLoaded', populateScrollingImages);

window.addEventListener('resize', populateScrollingImages);

window.addEventListener('orientationchange', populateScrollingImages);

document.addEventListener('shopify:section:load', populateScrollingImages);

const observer = new MutationObserver((mutationsList) => {
  renderAccordions();
  scaleLargeText();
});

document.addEventListener('DOMContentLoaded', () => {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener('DOMContentLoaded', populateScrollingText);

window.addEventListener('resize', populateScrollingText);

window.addEventListener('orientationchange', populateScrollingText);

document.addEventListener('shopify:section:load', populateScrollingText);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href]').forEach((link) => {
    link.setAttribute('tabIndex', '0');
  });
});